// components/blog/CategoryCreator.js
import React, { useState } from 'react';
import api from '../../utils/api';

const CategoryCreator = ({ onCreated, categories }) => {
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreateCategory = async () => {
    if (!name.trim()) return;

    setLoading(true);
    try {
      const res = await api.post('/api/blog-categories', {
        name: name.trim(),
        parent_id: parentId || null,
      });

      const newCategory = {
        id: res.data.id,
        name: name.trim(),
        parent_id: parentId || null,
      };

      onCreated(newCategory);
      setName('');
      setParentId('');
    } catch (err) {
      console.error('Error al crear categoría:', err);
      alert('No se pudo crear la categoría');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-4 space-y-2">
      <input
        type="text"
        placeholder="Nueva categoría"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="w-full px-3 py-2 text-sm border rounded-md"
      />
      <select
        value={parentId}
        onChange={(e) => setParentId(e.target.value)}
        className="w-full px-3 py-2 text-sm border rounded-md text-gray-700"
      >
        <option value="">Sin categoría padre</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.name}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={handleCreateCategory}
        disabled={loading}
        className="w-full mt-2 px-3 py-2 bg-black text-white rounded-md text-sm hover:bg-indigo-700 disabled:opacity-50"
      >
        {loading ? 'Creando...' : 'Crear categoría'}
      </button>
    </div>
  );
};

export default CategoryCreator;
